import {
  AutomationActionType,
  AutomationTaskInput
} from 'generated-graphql/types';
import { useEffect, useState } from 'react';
import { splitRulesAndActions } from 'modules/analyse/utils/splitRulesAndActions';
import { useGetCampaignNameByIdLazyQuery } from 'generated-graphql/hooks/apollo-hooks';
import { useLoadingOverlay } from 'services/loading/hooks';

export type CampaignNameMap = Record<string, string>;

export const useGetCampaignNames = ({
  automationTasks
}: {
  automationTasks: AutomationTaskInput[];
}) => {
  const { showLoadingOverlay, hideLoadingOverlay } = useLoadingOverlay();
  const [campaignNames, setCampaignNames] = useState<CampaignNameMap>({});

  const [getCampaignNamesId] = useGetCampaignNameByIdLazyQuery();

  useEffect(() => {
    const fetchCampaignNames = async () => {
      showLoadingOverlay();
      try {
        const { actions } = splitRulesAndActions(automationTasks);

        const campaignIds = actions
          .filter(
            (task) =>
              task.action.type === AutomationActionType.SendCampaign &&
              task.action.campaignId
          )
          .map((task) => task.action.campaignId as string)
          .filter((value, index, self) => self.indexOf(value) === index); // Get unique values

        const namesMap: CampaignNameMap = {};

        for (const campaignId of campaignIds) {
          try {
            const { data } = await getCampaignNamesId({
              variables: { id: campaignId }
            });

            if (data?.getCampaign?.title) {
              namesMap[campaignId] = data.getCampaign.title;
            }
          } catch (error) {
            namesMap[campaignId] = 'N/A';
          }
        }

        setCampaignNames(namesMap);
      } finally {
        hideLoadingOverlay();
      }
    };

    if (automationTasks && automationTasks.length > 0) {
      fetchCampaignNames();
    }
  }, [automationTasks, getCampaignNamesId]);

  return {
    campaignNames
  };
};
